import { Status } from '../interface/apiModels';

export interface Tenant {
  id: string;
  tenantKey: string;
  name: string;
  cupPassword: string;
  createdAt: Date;
  startTimestamp: Date;
  status: Status;
}

export interface TenantConfiguration {
  name: string;
  cupPassword: string;
  startTimestamp: Date;
  adminEmail: string;
  adminPassword: string;
  adminPasswordRepeat: string;
  useExistingAccount: boolean;
  consentReceiveEmails: boolean;
}

export const createEmptyTenantConfig = () => {
  const startTimestamp = new Date();
  startTimestamp.setHours(startTimestamp.getHours() + 1, 0, 0, 0);
  return {
    name: '',
    cupPassword: '',
    startTimestamp,
    adminEmail: '',
    adminPassword: '',
    adminPasswordRepeat: '',
    useExistingAccount: false,
    consentReceiveEmails: false,
  };
};
